var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.info.type,attrs:{"module-item":""}},[_c('AudioPlayer',{attrs:{"src":(_vm.cdnHost + "/" + (_vm.info.value.audio))}}),_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.enterToBr(_vm.info.value.desc))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }